var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "swiper" }, [
    _c("div", { staticClass: "swiper-wrapper" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "swiper-pagination" }),
    _vm._v(" "),
    _c("div", { staticClass: "swiper-button-prev" }),
    _vm._v(" "),
    _c("div", { staticClass: "swiper-button-next" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }